<template>
  <div class="login">
    <div class="col-lg-6 d-flex">
      <div class="column-position">
        <div class="login-panel">
          <h2>Zaloguj się do serwisu</h2>
          <BaseLoginForm />
        </div>
        <div class="login-bottom">
          <div class="login-copyright">
            <span>
              Copyright 2013-{{ new Date().getFullYear() }} ©
              <a href="https://cleanscripts.com">CleanScripts.com</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseLoginForm from "../components/authorization/BaseLoginForm";
export default {
  name: "TheLogin",
  components: { BaseLoginForm },
  methods: {}
};
</script>